import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

const breakpoints = createBreakpoints({});

function pxToRem(value) {
  return `${value / 16}rem`;
}

const styles = () => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: "10px",
    "flex-direction": "column"
  },
  header: {
    // fontWeight: "bold",
    // paddingBottom: 16
  },
  description: {
    paddingBottom: 16,
    paddingLeft: pxToRem(40),
    paddingRight: pxToRem(40)
  },
  video: {
    [breakpoints.down("md")]: {
      fontSize: pxToRem(16)
    },
    [breakpoints.down("sm")]: {
      fontSize: pxToRem(12)
    },
    [breakpoints.down("xs")]: {
      fontSize: pxToRem(8)
    },
    width: "40em",
    height: "22.5em",
    paddingBottom: 16
  }
});

class VimeoPlayer extends Component {
  render() {
    const { video } = this.props.location.state;
    const { classes } = this.props;
    console.log(video);
    if (video && video.id) {
      const src = `https://player.vimeo.com/video/${video.id}`;
      return (
        <div className={classes.container}>
          <h2 className={classes.header}>{video.title}</h2>
          <div className={classes.video}>
            <iframe
              title="Video1"
              src={src}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />
          </div>
          {video.descriptions &&
            video.descriptions.map((description) => (
              <span className={classes.description}>{description}</span>
            ))}
        </div>
      );
    } else {
      return null;
    }
  }
}

export default withStyles(styles)(VimeoPlayer);



// WEBPACK FOOTER //
// ./src/components/common/VimeoPlayer.js